/**
 * @file 常量表
 * @author weijiaxun <weijiaxun@baidu.com>
 */
const ua = navigator.userAgent;
/**
 * 当前环境是否为框，通过userAgent判断
 * @type {boolean}
 */
export const IS_LITE_BOX = / (lite|info) baiduboxapp\//i.test(ua);
export const IS_KANDUODUO_BOX = / mission baiduboxapp\//i.test(ua);
export const IS_BOX = / baiduboxapp\//i.test(ua) && !IS_LITE_BOX && !IS_KANDUODUO_BOX;
export const IS_BIG_BOX = / tomas\//i.test(ua);
/**
 * 当前系统是否为iOS
 * @type {boolean}
 */
export const IS_IOS = /(iPhone|iPod|iPad)/.test(ua);
/**
 * 当前系统是否为android
 * @type {boolean}
 */
export const IS_ANDROID = /(Android);?[\s/]+([\d.]+)?/.test(ua);
const oldMatch = /([\d+.]+)_(?:diordna|enohpi)_/.exec(ua);
const match = /baiduboxapp\/([\d+.]+)/.exec(ua);
/**
 * 获取百度 App 版本号
 *
 * @return {string} 版本号字符串
 */
function getVersion() {
    if (window.baiduboxapp_version) {
        return window.baiduboxapp_version;
    }
    if (IS_BOX) {
        if (match) {
            return match[1];
        }
        if (oldMatch) {
            return oldMatch[1].split('.').reverse().join('.');
        }
    }
    return 0;
}
/**
 * 当前框的版本号
 * @type {number}
 */
export const BOX_VERSION = getVersion();
/**
 * 当前框的版本号
 * @type {number}
 */
export const LITE_BOX_VERSION = IS_LITE_BOX && match ? match[1] : 0;
//# sourceMappingURL=index.js.map